module.exports = __webpack_public_path__ + "static/img/products discription_Semi-rigid PVC Film1.fe80a7c4.jpg";